import { render } from "./GeneralAlert.vue?vue&type=template&id=4c079c2e"
import script from "./GeneralAlert.vue?vue&type=script&lang=ts"
export * from "./GeneralAlert.vue?vue&type=script&lang=ts"
script.render = render

export default script